import * as govIdSelector from '../selectors/government-id.selectors';
import * as currentSelfieSelector from '../selectors/selfie.selectors';
import * as previousSelfieSelector from '../selectors/previous-selfie.selectors';
import * as currentHomeAddressSelector from '../selectors/home-address.selectors';
import * as fromPrivacySettingsSelector from '../selectors/privacy-setting.selectors';
import * as fromTaxYearsSelector from '../selectors/tax-years.selectors';
import * as fromTodosSelector from '../selectors/to-dos.selectors';
import * as fromSendTaxSelector from '../selectors/send-tax-years.selectors';
import * as fromGovIdProofSelector from '../selectors/gov-id-proof.selectors';
import * as fromBankProofSelector from '../selectors/bank-proof.selectors';
import * as fromOpenFileSelector from '../selectors/open-file.selectors';
import * as fromNoteSelectors from '../selectors/note.selectors';
import * as fromGenerateOtpSelector from '../selectors/generate-otp.selectors';
import * as fromEmployeeBusinessesSelector from '../selectors/employee-businesses.selectors';
import * as fromEmployeeWithdrawalsSelector from '../selectors/employee-withdrawals.selectors';
import * as fromUpdateMobileNumberSelector from '../selectors/update-mobile-number.selectors';
import * as fromGroupedCustomerProductsSelector from '../selectors/grouped-customer-products.selectors';
import * as fromGroupedProductsForSomeoneElseSelector from '../selectors/grouped-products-for-someone-else.selectors';
import * as fromGroupedProductsFromSomeoneElseSelector from '../selectors/grouped-products-from-someone-else.selectors';
import * as fromBotflowPlaybackSelector from '../selectors/botflow-playback.selectors';
import * as fromBankProofDocumentsSelector from './bankproof-documents.selectors';
import * as fromApproveBankProofDocumentSelector from './approve-bankroof-document.selectors';
import * as fromRejectBankProofDocumentSelector from './reject-bankroof-document.selectors';
import * as fromAddBankSelector from './add-bank.selectors';
import * as fromUpdateBankSelector from './update-bank.selectors';
import * as fromRemoveBankSelector from './remove-bank.selectors';
import { fromFilteredTransactions } from '../reducers';
import * as fromUpdateMemberDetailSelector from './update-member-detail.selectors';
import * as fromComplianceSelector from './compliance.selectors';
import * as fromEmployeeGovtIdDetailsSelector from './employee-govt-id-details.selectors';
import * as fromEmployeeHomeAddressSelector from './employee-home-address.selectors';
import * as fromDeleteCustomerSelector from './delete-customer.selectors';
import * as fromRestoreCustomerSelector from './restore-customer.selectors';

// Products
export * from './current-products.selectors';
export * from './grouped-customer-products.selectors';
export * from './archived-products.selectors';

export * from './notifications.selectors';

//Business Info
export * from './bi-details.selectors';
export * from './bank-details.selectors';

//IFA Rep Knowledge
export * from './ifa-search-products.selectors';
export * from './ifa-add-product-knowledge.selectors';
export * from './ifa-select-product-type.selectors';

//Archived Home Address
export * from './archived-home-address.selectors';

//Archived Proof Gov Id
export * from './archived-proof-gov-id.selectors';

// Archived Selfies
export * from './archived-selfies.selectors';

export * from './beneficiaries.selectors';

//Retirement Plan
export * from './retirement-plan.selectors';
// Monthly Income
export * from './monthly-income.selectors';
// Current Legal Documents
export * from './legal-documents-current.selectors';
// Previous Legal Documents
export * from './legal-documents-previous.selectors';
//FNA
export * from './fna.selectors';

//Statements
export * from './statements.selectors';
export * from './previous-statements.selectors';

export * from './transactions-all.selectors';
export * from './filtered-transactions.selectors';

// Products For Someone Else
export * from './current-products-for-someone-else.selectors';
export * from './past-products-for-someone-else.selectors';
export * from './upcoming-products-for-someone-else.selectors';
export * from './pending-products-for-someone-else.selectors';
export * from './grouped-products-for-someone-else.selectors';

// Products From Someone Else
export * from './current-products-from-someone-else.selectors';
export * from './past-products-from-someone-else.selectors';
export * from './upcoming-products-from-someone-else.selectors';
export * from './pending-products-from-someone-else.selectors';
export * from './grouped-products-from-someone-else.selectors';

export * from './employee-risk-products.selectors';

export {
  govIdSelector,
  fromBankProofSelector,
  currentSelfieSelector,
  previousSelfieSelector,
  currentHomeAddressSelector,
  fromPrivacySettingsSelector,
  fromTaxYearsSelector,
  fromTodosSelector,
  fromSendTaxSelector,
  fromGovIdProofSelector,
  fromOpenFileSelector,
  fromNoteSelectors,
  fromUpdateMobileNumberSelector,
  fromGenerateOtpSelector,
  fromGroupedCustomerProductsSelector,
  fromGroupedProductsForSomeoneElseSelector,
  fromGroupedProductsFromSomeoneElseSelector,
  fromEmployeeBusinessesSelector,
  fromEmployeeWithdrawalsSelector,
  fromBotflowPlaybackSelector,
  fromBankProofDocumentsSelector,
  fromApproveBankProofDocumentSelector,
  fromRejectBankProofDocumentSelector,
  fromAddBankSelector,
  fromUpdateBankSelector,
  fromRemoveBankSelector,
  fromFilteredTransactions,
  fromUpdateMemberDetailSelector,
  fromComplianceSelector,
  fromEmployeeGovtIdDetailsSelector,
  fromEmployeeHomeAddressSelector,
  fromDeleteCustomerSelector,
  fromRestoreCustomerSelector
};
